module.exports = function getResource(label, vars = []) {
    const resources = {
        close: 'Fermer',
        bopisItemAddedModalTitle: 'Article ajouté au panier',
        shippingItemAddedModalTitle: 'Ajouté à votre panier d’articles à faire livrer',
        viewBasketAndReserve: 'Voir le panier et réserver',
        viewBasketAndCheckout: 'Voir le panier et passer à la caisse',
        ropisItemAdded: 'L’article a été ajouté à votre panier',
        pickUpAt: 'pour ramassage au ',
        testCreditCardMessageBody: 'Earn 4% back in rewards when you use your Sephora Credit Card at Sephora.',
        testCreditCardMessageTitle: 'Don’t Forget to Use Your Sephora Credit Card',
        testCreditCardSeeDetails: 'Voir les détails',
        testCardDiscount: `Save ${vars[0]} off your Sephora order when you open and use your Sephora Credit Card.`,
        testCardDiscountTitle: 'Open a Sephora Credit Card Today',
        sameDayDeliveryConfirmation: `L’article a été ajouté à votre panier pour ${vars[0]} à `,
        item: 'Article',
        items: 'Articles'
    };

    return resources[label];
};
